import React, { Component } from 'react';
import qs from 'qs';
import { connect } from 'react-redux';
import { submit } from 'redux-form';
import { Link } from 'react-router-dom';

import Pagination from '../../components/Pagination/Pagination';
import SearchSubsForm from '../../components/SearchSubsForm';
import Spinner from '../../components/Spinner';
import { searchAllSubs } from '../../actions/allSubs';
import {
  getAllCarriersSubsWithoutLayover,
  getAllCarriersSubsWithoutLayoverPageCount,
  getLoggedInUser,
} from '../../reducers';
import OrderedSubList from '../../components/OrderedSubList/OrderedSubList';
import { viewSubUrl } from '../../helpers/subs';
import { encodeObjectValues } from '../../helpers/objects';
import { can, permActions } from '../../permissions';

export class SubSearch extends Component {
  state = {
    loading: false,
    wasSearch: false,
  };

  componentDidUpdate(oldProps) {
    if (oldProps.ordering !== this.props.ordering) {
      this.props.remoteSubmit('searchSubs');
    }
  }

  showLoader = () => this.setState({ loading: true });
  hideLoader = () => this.setState({ loading: false });

  searchSubs = (values) => {
    // check values isn't empty
    let isEmpty = true;
    for (let key in values) {
      if (values[key]) {
        isEmpty = false;
      }
    }
    if (isEmpty) {
      return;
    }

    const { searchAllSubs, history, ordering } = this.props;
    const { wasSearch } = this.state;

    history.push({
      search: `?page=1&ordering=${ordering}`,
    });

    if (wasSearch) {
      this.showLoader();
    } else {
      this.setState({
        loading: true,
      });
    }
    return searchAllSubs({
      ...encodeObjectValues(values),
      ordering,
    }).then(() => {
      this.setState({
        wasSearch: true,
      });
    });
  };

  handleChangeOrdering = (value) => {
    const { history } = this.props;
    history.push({
      search: `?page=1&ordering=${value}`,
    });
  };

  render() {
    const { subs, page, pageCount, ordering, loggedInUser } = this.props;
    const { loading, wasSearch } = this.state;
    let fields = [
      'first_name',
      'last_name',
      'mdn',
      'user_profile',
      'device_id',
      'icc_id',
    ];
    const showImsiSearchField = can(
      loggedInUser,
      permActions.SEARCH_ATT_SUB_BY_IMSI,
    );
    if (showImsiSearchField) {
      fields.push('imsi');
    }
    return (
      <div>
        <h1>Search subscriptions</h1>
        <SearchSubsForm
          onSubmit={this.searchSubs}
          onSubmitSuccess={this.hideLoader}
          onSubmitFail={this.hideLoader}
          fields={fields}
        />
        <br />
        {subs && subs.length > 0 && (
          <React.Fragment>
            <h2>Subscriptions list</h2>
            <OrderedSubList
              subs={subs}
              changeOrdering={this.handleChangeOrdering}
              ordering={ordering}
              actionComponent={(sub) => <Link to={viewSubUrl(sub)}>View</Link>}
              statusKey="status"
              showCarrier
              identifierTitle
            />
          </React.Fragment>
        )}
        {subs && subs.length === 0 && wasSearch && <div>No results found.</div>}
        <Pagination
          count={pageCount}
          current={page}
          url={(pageNum) => `/subs?page=${pageNum}&ordering=${ordering}`}
        />
        <Spinner showLoader={loading} />
      </div>
    );
  }
}

const mapStateToProps = (state, { location: { search } }) => {
  const { page = 1, ordering = '-id' } = qs.parse(search, {
    ignoreQueryPrefix: true,
  });
  return {
    loggedInUser: getLoggedInUser(state),
    subs: getAllCarriersSubsWithoutLayover(state, page),
    pageCount: getAllCarriersSubsWithoutLayoverPageCount(state),
    ordering,
    page,
  };
};

const mapDispatchToProps = {
  searchAllSubs,
  remoteSubmit: submit,
};

export default connect(mapStateToProps, mapDispatchToProps)(SubSearch);
